import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import ClippPlayer from 'clipp-player';
import InfiniteScroll from 'react-infinite-scroller';
import { InView } from 'react-intersection-observer';

import LoadingSpinner from '../Shared/LoadingSpinner';
import { calculateZoom } from '../../utils/podcastUtils';

import 'react-activity-feed/dist/index.css';
import 'react-sweet-progress/lib/style.css';
import '../Home/styles/ShowsLandingPage.scss';
import '../Home/styles/ShowPage.scss';
import ReactTooltip from 'react-tooltip';

export default class ClippList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      activeClipp: null,
    };

    this.showSearch = false;
    this.scrollWindow = React.createRef();

    //window.onresize = this.reportWindowSize;
  }

  componentDidMount() {
    this.setState({ loading: false });
  }

  reportWindowSize = () => {
    this.setState({ counterWidth: '4%' });

    setTimeout(() => {
      this.forceUpdate(() => {
        this.setState({ counterWidth: '5%' });
      });
    }, 1000);
  };

  renderReleaseDate = publishDate => {
    const date = moment(publishDate);

    return moment().diff(date, 'hours') > 24 ? date.format('MMM Do, YYYY') : date.fromNow();
  };

  isVisible = inView => {
    if (inView) {
      ReactTooltip.rebuild();
      this.props.loadMore();
    }
  };

  setActiveClipp = clippId => {
    this.setState({ activeClipp: clippId === this.state.activeClipp ? null : clippId });
  };

  renderItems = () => {
    const { user, loadMore, items, hasMore } = this.props;
    const { loading, activeClipp } = this.state;

    return (
      <InView as='div' onChange={this.isVisible}>
        <InfiniteScroll
          pageStart={0}
          loadMore={loadMore.bind(this)}
          hasMore={hasMore}
          loader={
            <div className='loader' style={{ height: '100px' }} key={0}>
              <LoadingSpinner />
            </div>
          }
          useWindow={false}
          getScrollParent={() => this.scrollWindow.current}
        >
          {items.map(item => {
            return (
              <div className='episode-container' key={item.id}>
                <ReactTooltip className='tooltip' effect='solid' delayShow={500} />
                <div className='clipp-title'>{item.title}</div>
                <div className='clipp-delete' data-tip='Delete Clipp'>
                  {item.createdBy === user.id ? <i className='far fa-times' /> : null}
                </div>
                <div className='audio-player-container full-width'>
                  {!loading && (
                    <ClippPlayer
                      className='clipp-player'
                      src={item.audioUrl}
                      isPlaying={activeClipp === item.id}
                      togglePlay={this.setActiveClipp.bind(null, item.id)}
                      btnStyle={{
                        color: '#FFF',
                        background: 'rgb(79, 73, 226)',
                        borderRadius: '30px',
                      }}
                      counterStyle={{
                        color: 'rgb(79, 73, 226)',
                      }}
                      initialDuration={item.duration}
                      volume={1}
                      zoom={calculateZoom(item.duration)}
                      options={{
                        audioRate: 1,
                        autoCenter: false,
                        barGap: 1,
                        barWidth: 2.5,
                        barHeight: 1,
                        cursorWidth: 1,
                        cursorColor: 'rgb(79, 73, 226)',
                        fillParent: true,
                        height: 100,
                        hideScrollbar: true,
                        normalize: true,
                        partialRender: true,
                        progressColor: 'rgb(79, 73, 226)',
                        responsive: true,
                        waveColor: '#e1e5ea',
                      }}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </InfiniteScroll>
      </InView>
    );
  };

  render() {
    const { isLoading, searchFunc, items, itemName, searchTermRef, searchWatcher, resultCount } = this.props;

    return (
      <React.Fragment>
        {this.showSearch && (
          <div className='episode-search'>
            <form onSubmit={searchFunc} onChange={searchWatcher}>
              <input
                className='episode-search-input'
                type='text'
                ref={searchTermRef}
                placeholder={`Search ${itemName}...`}
                required
              />
              <input className='episode-search-btn' type='submit' value='Search' />
            </form>
            {!!resultCount && <div className='result-count'>{`Results: ${resultCount}`}</div>}
            <div className='order-by' onClick={this.toggleSort}>
              {this.props.orderBy === 'asc' ? (
                <i className='far fa-sort-amount-up' />
              ) : (
                <i className='far fa-sort-amount-down' />
              )}
            </div>
          </div>
        )}
        {_.size(items) || isLoading ? this.renderItems() : <div className='no-results'>No Clipps Yet!</div>}
      </React.Fragment>
    );
  }
}

ClippList.propTypes = {
  user: PropTypes.object,
  darkMode: PropTypes.bool,
  activeItem: PropTypes.object,
  episodePlaying: PropTypes.bool,
  setActiveItem: PropTypes.func.isRequired,
  shareItem: PropTypes.func,
  loadMore: PropTypes.func.isRequired,
  searchFunc: PropTypes.func.isRequired,
  redirectTo: PropTypes.func,
  items: PropTypes.array.isRequired,
  itemName: PropTypes.string,
  orderBy: PropTypes.string,
  resultCount: PropTypes.number,
};

ClippList.defaultProps = {
  user: {},
  darkMode: false,
  itemName: 'Episode',
};
